import React, { useState } from "react";
import ProductBanner from "./components/product-banner";
import { PRODUCTS, WORKING_CAPITAL_LOAN_INFO } from "../../constants/products";
import ProductBenefit, {
  ProductBenefitContent,
} from "./components/product-benefit";
import lowInterestIcon from "../../assets/images/products/low-interest.png";
import moneyCircleIcon from "../../assets/images/products/money-circle.png";
import transparantIcon from "../../assets/images/products/transparancy.png";
import { Container } from "react-bootstrap";
import ProductClosingStatement from "./components/product-closing-statement";
import ProductInterest from "./components/product-interest";
import ProductHow, { ProductHowContent } from "./components/product-how";
import WorkingCapitalRegistrationModal from "../../components/products/working-capital-registration-modal";
import ProductPartner from "./components/product-partner";
import { LOAN_LIMIT_TEXT } from "../../constants";
import RequiredDocuments from "./components/required-documents";
import ProductWorkingCapitalSimulation from "./components/product-working-capital-simulation";

const CONTENTS: ProductBenefitContent[] = [
  {
    title: "Bunga Rendah",
    image: lowInterestIcon,
    description: `Bunga antara ${Intl.NumberFormat("id-ID").format(WORKING_CAPITAL_LOAN_INFO.interestRate.start)} - ${Intl.NumberFormat("id-ID").format(WORKING_CAPITAL_LOAN_INFO.interestRate.end)}% per bulan, dengan tenor maksimal 12 bulan.`,
  },
  {
    title: "Limit Tinggi",
    image: moneyCircleIcon,
    description:
      "Pinjaman maksimal " +
      LOAN_LIMIT_TEXT +
      " rupiah yang disesuaikan dengan credit score dan penggunakan dana.",
  },
  {
    title: "Biaya Transparan",
    image: transparantIcon,
    description: `Mulai dari 1% per transaksi yang akan diinformasikan sebelum proses pencairan dana.`,
  },
];

function WorkingCapitalLoan() {
  const product = PRODUCTS.capitalLoan;
  const [registerCapitalLoan, setRegisterCapitalLoan] = useState(false);

  const partner = {
    title1: "Perusahaan yang telah menggunakan",
    title2: product.title,
    titleDescription: "",
    product: "working-capital-loan",
    description: "",
  };

  const CONTENT_HOW: ProductHowContent[] = [
    {
      title: "Pendaftaran",
      description: (
        <React.Fragment>
          Pendaftaran dilakukan secara mandiri dengan mengklik{" "}
          <a
            href="/"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setRegisterCapitalLoan(true);
            }}
          >
            registrasi/daftar
          </a>{" "}
          serta melengkapi dokumen yang dipersyaratkan.
        </React.Fragment>
      ),
    },
    {
      title: "Proses Pengajuan dan Verifikasi",
      description: (
        <React.Fragment>
          Ajukan pinjaman dengam melampirkan dokumen yang dipersyaratkan. Tim
          Pohon Dana akan melakukan verifikasi data serta analisa secara
          menyeluruh.
        </React.Fragment>
      ),
    },
    {
      title: "Persetujuan",
      description: (
        <React.Fragment>
          Calon peminjam akan mendapatkan rekomendasi pengajuan pinjaman dan
          berhak untuk menyetujui atau menolak rekomendasi tersebut. Apabila
          menerima, peminjam wajib menandatangani perjanjian secara elektronik.
        </React.Fragment>
      ),
    },
    {
      title: "Proses Pencairan",
      description: (
        <React.Fragment>
          Setelah penandatanganan, pinjaman akan diteruskan kepada pihak pemberi
          dana untuk proses pencairan dana. Proses pencairan akan dilakukan
          dalam waktu 1 x 24 jam.
        </React.Fragment>
      ),
    },
  ];

  return (
    <div className="main-container" id="product-page">
      <ProductBanner product={product} />
      <Container className="my-5">
        <ProductBenefit
          title={
            <React.Fragment>
              <span className="text-primary-main">Keuntungan</span>{" "}
              {product.title}
            </React.Fragment>
          }
          contents={CONTENTS}
        />
      </Container>
      <ProductInterest
        position="right"
        title={
          <React.Fragment>
            <span className="text-primary-main">Biaya</span> Pinjaman untuk{" "}
            <span className="text-primary-main">Modal Kerja</span>
          </React.Fragment>
        }
        interestMin={WORKING_CAPITAL_LOAN_INFO.interestRate.start}
        interestMax={WORKING_CAPITAL_LOAN_INFO.interestRate.end}
        caption={
          <React.Fragment>
            <div>Biaya Pinjaman - mulai dari 1% per transaksi</div>
            <div>Biaya Keterlambatan - 1,5% per bulan (pro rata)</div>
          </React.Fragment>
        }
      />
      <Container className="mt-5 pt-5">
        <ProductHow
          marginBottom={2}
          product={product}
          contents={CONTENT_HOW}
          additionalTitleInfo={
            <div className="mt-4 d-none d-lg-block">
              <RequiredDocuments
                fontSizeTitle="sub-body-2"
                fontSizeContentTitle="caption"
                fontSizeContent="caption"
              />
            </div>
          }
        />
        <div className="mt-4 d-block d-lg-none">
          <RequiredDocuments
            fontSizeTitle="body-head"
            fontSizeContentTitle="sub-body-2"
            fontSizeContent="sub-body-2"
          />
        </div>
      </Container>
      <ProductWorkingCapitalSimulation />
      <ProductPartner data={partner} />

      <Container className="my-5">
        <ProductClosingStatement
          caption="Butuh modal tambahan untuk bisnis anda?"
          title="Ajukan Pinjaman Dana di Pohon Dana!"
          product={product}
          buttonText="Ajukan Pinjaman"
        />
      </Container>
      {registerCapitalLoan && (
        <WorkingCapitalRegistrationModal
          onHide={() => setRegisterCapitalLoan(false)}
        />
      )}
    </div>
  );
}

export default WorkingCapitalLoan;
